// 小程序平台号枚举
export const MP_PLATFORM = {
    // 知屿
    TingZhi: '14',
    // 易起测算
    YiQiCeSuan: '21',
    // 易起问
    YiQiWen: '29',
    // 知屿测算
    TingZhiCeSuan: '30',
    // 知屿妙算
    TingZhiMiaoSuan: '41',
    // 易起妙算
    YiQiMiaoSuan: '42',
    // 知屿问答
    TingZhiWenDa: '27',
    // 易起咨询
    YiQiZiXun: '17',
    // 知屿问问
    TingZhiWenWen: '70',
    // 猫耳倾述
    MaoErQianShu: '7',
    // 幸喵星座
    XingMiaoXingZuo: '61',
    // 知屿咨询
    TingZhiZiXun: '9',
    // 易起倾述
    YiQiQingShu: '11',
    // 易起测测
    YiQiCeCe: '35',
    // 知屿达人
    TingZhiDaRen: '69',
    // 逆位咖啡
    NiWeiKaFei: '56',
  };
  